import React, { useCallback } from 'react'
import './TopNavigation.css'

interface ITopMenuExpandButtonProps {
  expanded: boolean
  onToggle: () => void
}

const TopMenuExpandButton: React.FC<ITopMenuExpandButtonProps> = ({
  expanded,
  onToggle,
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      onToggle()
    },
    [onToggle]
  )

  return (
    <a
      href='/#/'
      onClick={handleClick}
      id='top-menu-toggler'
      className={expanded ? 'my-auto on' : 'my-auto'}
    >
      <span></span>
    </a>
  )
}
export default TopMenuExpandButton
